import BadgesCard from 'components/BadgesCard';
import { Loading } from 'components/LottieFiles';
import ObjectsCard from 'components/ObjectsCard';
import StatisticsCard from 'components/StatisticsCard';
import { PLACE_ID } from 'config/constant';
import { GET_BADGES, GET_OBJECTS } from 'config/queries';
import { handleStatisticsItems } from 'helpers/RewardsHelper';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import useRewards from 'store/useRewards';
import useUser from 'store/useUser';
// import { statisticsItems } from './data';
import { Wrapper } from './Rewards.styles';
import { statisticsItemsType } from './Rewards.type';
import { getBadges, getObjects } from './services';
import useSound from 'use-sound';
import ClickSound from 'assets/sounds/Tap.wav';

const Rewards = () => {
  const [playClick] = useSound(ClickSound);
  // sates
  const { isLogged } = useUser();
  const { badges, objects, coins } = useRewards();
  const [statisticsItems, setStatisticsItems] = useState<
    Array<statisticsItemsType>
  >([]);
  const navigate = useNavigate();
  const handleSeeAll = (path: string) => {
    playClick();
    navigate(path);
  };
  // get Data
  const badgesList = useQuery(GET_BADGES, () => getBadges(PLACE_ID));
  const objectsList = useQuery(GET_OBJECTS, () => getObjects(PLACE_ID));

  useEffect(() => {
    if (!isLogged) {
      navigate('/start');
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // check if objects is loaded or is stored on localestorage
    if (objects && badges) {
      const data = handleStatisticsItems(badges.length, objects.length, coins);
      setStatisticsItems(data);
    }
    // eslint-disable-next-line
  }, [objects, badges]);

  return (
    <Wrapper>
      {statisticsItems.length > 0 ? (
        <StatisticsCard items={statisticsItems} className="mb-6" />
      ) : (
        <Loading />
      )}
      {!objectsList?.isLoading && objects ? (
        <ObjectsCard
          items={objects.slice(0, 3)}
          handleSeeAll={() => handleSeeAll('all-objects')}
          className="mb-[5rem]"
        />
      ) : (
        <Loading />
      )}
      {!badgesList?.isLoading && badges ? (
        <BadgesCard
          badges={badges.slice(0, 9)}
          handleSeeAll={() => handleSeeAll('all-badges')}
        />
      ) : (
        <Loading />
      )}
    </Wrapper>
  );
};

export default Rewards;
